import Image from "next/image";
import Link from "next/link";
import cta_logo from "@/assets/img/cta/HTU-X-Logo.svg";

export default function CtaOne() {
  return (
    <section
      className="cta-area tp-cta-bg red-bg pt-50 pb-50"
      style={{ direction: "ltr", fontFamily: "ScalaSansPro" }}
    >
      <div className="container">
        <div
          className="row align-items-center wow fadeInUp"
          data-wow-delay=".2s"
        >
          <div className="col-xxl-10 col-lg-9">
            <div className="tp-cta-wrapper d-flex align-items-center">
              <div className="tp-cta-logo">
                <Image
                  src={cta_logo}
                  alt="HTU X Logo"
                  width={120}
                  height={58}
                />
              </div>
              <div className="tp-cta-content">
                <h5 className="white-color">
                  Upgrade your employability through HTUx’s
                </h5>
                <h3 className="tp-cta-title">
                  Study alone play together, tech-focused, accelerated learning
                  pathways!
                </h3>
              </div>
            </div>
          </div>
          <div className="col-xxl-2 col-lg-3">
            <div className="tp-cta-btn-wrap">
              <div className="tp-cta-btn text-lg-end">
                <Link
                  className="tp-btn"
                  href="https://htux.org/"
                  target="_blank"
                  title="Join HTUx Now!"
                  rel="noopener noreferrer"
                  style={{
                    fontSize: "0.95rem",
                  }}
                >
                  Join HTUx Now!
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
